export default {
  __html: `<g fill="#201A5B" fill-rule="nonzero">
                <path d="M72.6 51.6H9.7c-5.2 0-9.4-4.2-9.4-9.4V10C.3 4.8 4.5.6 9.7.6h62.9C77.8.6 82 4.8 82 10v32.2c0 5.1-4.2 9.4-9.4 9.4zM9.7 6.7c-1.8 0-3.3 1.5-3.3 3.3v32.2c0 1.8 1.5 3.3 3.3 3.3h62.9c1.8 0 3.3-1.5 3.3-3.3V10c0-1.8-1.5-3.3-3.3-3.3H9.7z"/>
                <path d="M41 34.9c-1.1 0-2.2-.6-2.7-1.6-.8-1.5-.2-3.3 1.3-4.1l26.6-14.1c1.5-.8 3.3-.2 4.1 1.3.8 1.5.2 3.3-1.3 4.1L42.4 34.6c-.4.2-.9.3-1.4.3z"/>
                <path d="M41 34.9c-.5 0-1-.1-1.4-.4L13 20.4c-1.5-.8-2.1-2.7-1.3-4.1.8-1.5 2.7-2.1 4.1-1.3l26.6 14.1c1.5.8 2.1 2.7 1.3 4.1-.6 1.1-1.6 1.7-2.7 1.7z"/>
            </g>`
}



// WEBPACK FOOTER //
// ./src/app/elements/Icon/share.js